/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Toast_Update_ErrorInputs */

const he_account_reviews_toast_update_error = /** @type {(inputs: Account_Reviews_Toast_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה בעדכון הביקורת`)
};

const en_account_reviews_toast_update_error = /** @type {(inputs: Account_Reviews_Toast_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update review`)
};

/**
* | output |
* | --- |
* | "Failed to update review" |
*
* @param {Account_Reviews_Toast_Update_ErrorInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_toast_update_error = /** @type {((inputs?: Account_Reviews_Toast_Update_ErrorInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Toast_Update_ErrorInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_toast_update_error(inputs)
	return en_account_reviews_toast_update_error(inputs)
});